import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { prepareQueryArgsForTableFetch } from "../fetchTableValue";
import { getValueWithMapLinks, prepareTableData, transformResponse } from "../../../../features/dataFormatFunctions/dataFormatter";
import { store } from "../../../../stateManagement/store";
import { csvExport, excelExport, pdfExport } from "../tableExport";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { classNames } from "primereact/utils";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { setTableCSVExportWindowIsShown, setTableEXCELExportWindowIsShown, setTablePDFExportWindowIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice";
import { getDataArrayWithMaintenanceEnding, getDataArrayWithMaintenancePosition } from "../../../../features/dataFormatFunctions/formatMaintenancePoint";

export const exportTypes = ['pdf', 'csv', 'excel']
const possibleEventTypes = ['Диагностика', 'Мониторинг', 'Диагностика (плановая)']

const close_icon = require('../../../../assets/images/icons/close_icon.png')
const objects_icon = require('../../../../assets/images/icons/objects_icon.png')

// Компонент - окно экспорта для таблиц
export function TableExportComponent({ dataCount, tableState, columns, objectType, type, url, pathId, exportType, eventId, measureId, defectClassificator, initFilterStringArray, initSortQueryArgsParameters, exportName }: any) {
    const dispatch = useDispatch()
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app

    const [exportStart, setExportStart] = useState<any>(null);
    const [exportStartInputError, setExportStartInputError] = useState<boolean>(false)
    const [exportEnd, setExportEnd] = useState<any>(null);
    const [exportEndInputError, setExportEndInputError] = useState<boolean>(false)
    const [exportStartEndOrderError, setExportStartEndOrderError] = useState<boolean>(false)
    const [partExportLoader, setPartExportLoader] = useState<boolean>(false)
    const [fullExportLoader, setFullExportLoader] = useState<boolean>(false)
    const { tablePDFExportWindowIsShown, tableCSVExportWindowIsShown, tableEXCELExportWindowIsShown } = useAppSelector(state => state.contentHeader)

    const typeToShowMark: any = {
        'csv': tableCSVExportWindowIsShown,
        'pdf': tablePDFExportWindowIsShown,
        'excel': tableEXCELExportWindowIsShown
    }

    function changeExportStart(e: any) {
        if ((e.value < 1 || e.value > dataCount) && e.value != null) {
            setExportStartInputError(true)
            setExportStart(false)
        } else if (e.value == null) {
            setExportStart(false)
            setExportStartInputError(false)
        } else {
            setExportStart(e.value)
            setExportStartInputError(false)
        }
    }

    function changeExportEnd(e: any) {
        if ((e.value < 1 || e.value > dataCount) && e.value != null) {
            setExportEndInputError(true)
            setExportEnd(false)
        } else if (e.value == null) {
            setExportEnd(false)
            setExportEndInputError(false)
        } else {
            setExportEnd(e.value)
            setExportEndInputError(false)
        }
    }

    function closeExportWindow() {
        dispatch(setTablePDFExportWindowIsShown(false))
        dispatch(setTableEXCELExportWindowIsShown(false))
        dispatch(setTableCSVExportWindowIsShown(false))
        setExportStartEndOrderError(false)
        setExportEndInputError(false)
        setExportStartInputError(false)
        setExportStart(null)
        setExportEnd(null)
    }

    useEffect(() => {
        if (!tablePDFExportWindowIsShown || !tableCSVExportWindowIsShown || !tableEXCELExportWindowIsShown) {
            setExportStartEndOrderError(false)
            setExportEndInputError(false)
            setExportStartInputError(false)
            setExportStart(null)
            setExportEnd(null)
        }
    }, [tablePDFExportWindowIsShown, tableCSVExportWindowIsShown, tableEXCELExportWindowIsShown])

    let valueToExport: any = []
    let requiredFields: any = []
    let fieldsLocal: any = []

    async function exportTable(full: boolean) {
        valueToExport = []
        requiredFields = []
        fieldsLocal = []
        let exportS, exportE
        if (full) {
            exportS = 1;
            exportE = dataCount
        } else {
            exportS = exportStart
            exportE = exportEnd
        }
        if (exportS > exportE) {
            setExportStartEndOrderError(true)
        } else {
            if (full) {
                setFullExportLoader(true)
            } else {
                setPartExportLoader(true)
            }
            setExportStartEndOrderError(false)
            try {
                let { sortQueryArgsParameters, filterStringArray }: any = prepareQueryArgsForTableFetch(tableState, columns)
                if (objectType === 'RoadDiagnosticsSegments') {
                    let possibleEventsFilter: string
                    possibleEventsFilter = `(${possibleEventTypes.map((type: any) => `(EventTypeString eq '${type}')`).join(' or ')})`
                    filterStringArray.push(possibleEventsFilter)
                }
                if (objectType === 'RoadMeasures' || objectType === 'DefectSegmentGOST' || objectType === 'DefectSegmentODM') {
                    filterStringArray.push(`EventId eq ${eventId}`)
                }
                if (type === 'RoadMeasureResults') {
                    filterStringArray.push(`MeasureId eq ${measureId}`)
                }
                if (objectType === 'DefectSegmentGOST' || objectType === 'DefectSegmentODM') {
                    filterStringArray.push(`DefectClassificator eq ${defectClassificator}`)
                }
                if (initFilterStringArray) {
                    filterStringArray = initFilterStringArray.slice()
                }
                if (initSortQueryArgsParameters) {
                    sortQueryArgsParameters = initSortQueryArgsParameters.slice()
                }
                const response = await fetch(`${currentApiUrl}/${url}/?$skip=${exportS - 1}&$inlinecount=allpages&$orderby=${sortQueryArgsParameters}
                &$top=${exportE - exportS + 1}&$filter=(${filterStringArray.length > 0 ? filterStringArray.join(' and ') : `${null} eq ${null}`} ${!pathId ? '' : `and pathId eq ${pathId}`})`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch');
                }
                const data = await response.json()
                let value = transformResponse(data).value
                // добавление поля ссылка на карту для каждого объекта
                value = getValueWithMapLinks(value, objectType)
                value = prepareTableData(value, columns)
                value = getDataArrayWithMaintenancePosition(value)
                value = getDataArrayWithMaintenanceEnding(value)

                columns.map((col: any) => {
                    if (col.pdfHeader && !col.hidden) {
                        requiredFields.push(col.field)
                        fieldsLocal.push({ field: col.field, name: col.pdfHeader })
                    }
                })
                // форматирование значений для экспорта 
                value && value.map((item: any) => {
                    let object: any = {}
                    requiredFields.map((field: any, index: any) => {
                        if (Object.keys(item).includes(field)) {
                            object[index] = item[field]
                        }
                    })
                    valueToExport.push(object)
                })
                exportType === 'pdf' && pdfExport(valueToExport, columns, exportName)
                exportType === 'excel' && excelExport(valueToExport, columns, exportName)
                exportType === 'csv' && csvExport(valueToExport, columns, exportName)
                setPartExportLoader(false)
                setFullExportLoader(false)
            } catch (error) {
                // Выводим сообщение об ошибке в консоль
                console.error('Fetch error:', error);
            }
        }
    }

    let exportStartInputLabelClassName = classNames({
        'p-error': exportStartInputError
    })

    let exportStartInputSupClassName = classNames({
        "text-muted": true,
        'p-error': exportStartInputError
    })

    let exportStartInputClassName = classNames({
        'p-invalid': exportStartInputError
    })

    let exportEndInputLabelClassName = classNames({
        'p-error': exportEndInputError
    })

    let exportEndInputSupClassName = classNames({
        "text-muted": true,
        'p-error': exportEndInputError
    })

    let exportEndInputClassName = classNames({
        'p-invalid': exportEndInputError
    })

    return (
        <>
            {typeToShowMark[exportType] &&
                <div className="table-info table-export-div">
                    <h5 className="ms-4">Экспорт в {exportType.toUpperCase()}</h5>
                    {dataCount > 0
                        ?
                        <>
                            <p><img src={objects_icon} /><strong>Количество объектов:</strong> <span>{dataCount}</span></p>
                            <p><div className="ms-4">Выберите диапазон строк для экспорта:</div> <span className="table-info-value"></span></p>
                            <div className="export-input-div">
                                <div className="d-flex flex-column ms-4">
                                    <label className={exportStartInputLabelClassName}>
                                        Начало
                                        <sup className={exportStartInputSupClassName}>{`(>=1)`}</sup>
                                    </label>
                                    <InputNumber
                                        useGrouping={false}
                                        id="exportStart"
                                        className={exportStartInputClassName}
                                        onChange={(e) => changeExportStart(e)}
                                        style={{ width: '150px', height: '35px' }} />
                                </div>
                                <div className="d-flex flex-column ms-4">
                                    <label className={exportEndInputLabelClassName}>
                                        Конец
                                        <sup className={exportEndInputSupClassName}>{`(<=${dataCount})`}</sup>
                                    </label>
                                    <InputNumber
                                        useGrouping={false}
                                        id="exportEnd"
                                        className={exportEndInputClassName}
                                        onChange={(e) => changeExportEnd(e)}
                                        style={{ width: '150px', height: '35px' }} />
                                </div>
                                <div className="d-flex flex-column justify-content-end">
                                    {exportStartEndOrderError &&
                                        <div>
                                            <span className="p-error ms-2">Ошибка: "Конец" {`<`} "Начало"</span>
                                        </div>
                                    }
                                    <span className="p-buttonset export-buttons-div align-items-end ms-2" >
                                        <Button
                                            disabled={(exportStartInputError || exportEndInputError) || !exportEnd || !exportStart || partExportLoader}
                                            onClick={() => exportTable(false)}
                                            className="d-flex justify-content-center export-part-button"
                                            size="small"
                                            severity="success"
                                            style={{ width: '120px', height: '35px' }}
                                            icon={!partExportLoader ? "pi pi-check" : ''}
                                        >
                                            {partExportLoader &&
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            }
                                            <span className="p-button-label p-c ">Экспорт</span>
                                        </Button>
                                        <Button
                                            disabled={fullExportLoader}
                                            onClick={() => exportTable(true)}
                                            className="d-flex justify-content-center export-full-button"
                                            size="small"
                                            style={{ width: '210px', height: '35px' }}
                                            icon={!fullExportLoader ? "pi pi-database" : ''}
                                        >
                                            {fullExportLoader &&
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            }
                                            <span className="p-button-label p-c">Экспорт всех данных</span>
                                        </Button>
                                        <Button
                                            label="Отмена"
                                            onClick={() => closeExportWindow()}
                                            className="d-flex justify-content-center cancel-button"
                                            size="small"
                                            severity="secondary"
                                            style={{ width: '100px', height: '35px' }}
                                            icon="pi pi-times"
                                        />
                                    </span>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <span><b className="ms-4 no-export-data">Отсутствуют данные для экспорта</b></span>
                            <div className="table-info-close-div" onClick={() => closeExportWindow()}>
                                <img src={close_icon} width="25px" height="25px" />
                            </div>
                        </>
                    }
                </div>
            }
        </>
    );
}


